import styled, {ThemeProps} from 'styled-components';
import {Column} from './../../common/Layouts/Layouts';
import {Assign} from 'utility-types';
import {Theme} from '../../../../theme/types';

import RatingStarIcon from '../../../../Icons/RatingStarIcon';

export const WrapperDivRight = styled.section(
  (
    props: Assign<
      ThemeProps<Theme>,
      {
        sticky?: boolean;
      }
    >,
  ) => `

  // width: 75%;
  // height: 100%;
  background: props.theme.colors.white.base

  // z-index: ${props.sticky ? 1 : 0};
  position: ${props.sticky ? 'sticky' : 'static'};

  /*
    https://www.w3schools.com/cssref/pr_pos_left.asp
    If position: static; - the left property has no effect.
  */
  left: 0;

  box-shadow: ${props.currentHotel ? '10px 0px 16px 0px rgb(210, 210, 210)' : 'inherit'};

  border-bottom: 1px solid ${props.theme.colors.blue.blueBorder};

`,
);

export const OuterWrapperSection = styled.section(
  (
    props: Assign<
      ThemeProps<Theme>,
      {
        backgroundColor?: string;
        // boxShadow?: string;
        // zIndex?: number;
        // borderTop: string;
      }
    >,
  ) => `
  background: ${props.backgroundColor ? props.backgroundColor : props.theme.colors.white.base};
  
  display: flex;
  position: relative;

  // z-index: ${props.zIndex ? props.zIndex : 0};
  z-index: 1;
  height:100%;
  /* border-top: ${props.borderTop}; */
`,
);

export const SimilarHotelBorder = styled(Column)((props: Assign<ThemeProps<Theme>, {}>) => {
  const border = props.currentHotel ? 'none' : `1px solid ${props.theme.colors.blue.blueBorder}`;

  return `
    border: ${border};
    border-radius: ${props.theme.misc.borderRadius.base};
    padding: ${props.theme.spacing.small.s8};
    justify-content: space-between;
    margin-top: ${props.theme.spacing.base};
  `;
});

export const SelectRoomButton = styled(Column)(
  props => `

  display:flex;
  background-color: ${
    props.backgroundColor ? props.backgroundColor : props.theme.colors.goBrand.orange
  };
  font-weight: bold;
  border: none;
  color: ${props.color ? props.color : props.theme.colors.white.base};
  font-size: ${props.theme.font.large.font16};
  width: 100%;
  line-height: 1.38;
  padding: ${props.theme.spacing.small.s5} ${props.theme.spacing.base};
  border-radius: ${props.theme.misc.borderRadius.base};
  font-family:${props.theme.font.fontFamily};
  cursor: pointer;
`,
);

export const SimilarHotelPricingWrapper = styled(Column)(
  props => `

  display:flex;
  flex-direction:row;
  justify-content:space-between;
  padding-bottom: ${props.theme.spacing.small};

`,
);

export const SelectButtomOuterWrap = styled(Column)(
  props => `

  display:flex;
  justify-content: flex-end;
  margin-top: ${props.theme.spacing.large.l25};
`,
);

export const InnerWrapperWidth = styled(Column)(
  props => `

  padding: ${props.theme.spacing.small.s8};
`,
);

export const SimilarHotelWrapDiv = styled(Column)(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  width:100%;
  font-weight:bold;
  font-size:${props.theme.font.large.font16};
  color:${props.theme.colors.black.base};
  padding: 0 ${props.theme.spacing.small.s8};
`,
);

/**
 * hidden to just have div structure
 * other option could have been to have fixed height
 * for this container
 */
export const SimilarHotelTextHidden = styled.span`
  opacity: 0;
  visibility: hidden;
`;



// ==============================================================================================================

export const SimilarCaroCard = styled.div(
  props => `
    width: 25rem;
    display: flex;
    flex-direction: column;
    background-color:  ${props.currentHotel ? props.theme.colors.blue.lightf2 : props.theme.colors.white.base};
    border-radius: ${props.currentHotel ? `${props.theme.misc.borderRadius.base} ${props.theme.misc.borderRadius.base} 0 0` :  props.theme.misc.borderRadius.base};
    border: solid 0.7px ${props.theme.colors.grey.lightba};  
    box-shadow: ${props.currentHotel ? `0 4px 8px 0 rgba(138, 107, 118, 0.4)` : ''};
    margin-left: ${props.currentHotel ? '' : props.theme.spacing.large.l18};
  `
);

export const SelectedHotelImgWrap = styled.div(
  props => `
      display: flex;
      width: 25rem;
      height: 14rem;  
      border-radius: ${props.theme.misc.borderRadius.base} ${props.theme.misc.borderRadius.base} 0 0;
  `
);

export const SelectedImg = styled.img(
  props => `
      width: 99.5%;
      height: 14rem;
      border-radius: ${props.theme.misc.borderRadius.base} ${props.theme.misc.borderRadius.base} 0 0;
  `
);

export const SelectedHotelDetailBlock = styled.div(
  props => `
      width: 100%;
      height: 16rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: ${props.theme.spacing.base};
      justify-contnet: center;
  `
);

export const SelectedHotelName = styled.p(
  props => `
      font-size: ${props.theme.font.large.font16};
      color: ${props.theme.colors.black.base};
      font-weight: ${props.theme.font.fontWeight.bold};
      letter-spacing: ${props.theme.font.letterSpacing.large};  
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width:100%;
      text-align:center;
  `
);

export const SelectedHotelsStar = styled.div(
  props => `
      width:100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: ${props.theme.spacing.small.s5};  
  `
);

export const SelectedHotelPrice = styled.p(
  props => `
      font-size: ${props.theme.font.large.font22};
      color: ${props.theme.colors.black.base};
      font-weight: ${props.theme.font.fontWeight.black};
      letter-spacing: ${props.theme.font.letterSpacing.large};
      padding-top: ${props.theme.spacing.small.s5};  
  `
);

export const SelectedNightText = styled.p(
  props => `
      font-size: ${props.theme.font.base};
      color: ${props.theme.colors.grey.light9b};
      letter-spacing: ${props.theme.font.letterSpacing.large};  
  `
);

export const SelectedBtnWrap = styled.div(
  props => `
      width: 100%;
      display: flex;
      justify-content: center;
      padding: ${props.theme.spacing.base} ${props.theme.spacing.nospacing} ${props.theme.spacing.nospacing};
  `
);

export const SelectedBtn = styled.button(
  props => `
      padding: ${props.theme.spacing.small.s8} ${props.theme.spacing.large.l20};
      display: flex;
      font-size: ${props.theme.font.base};
      color: ${props.theme.colors.white.base};
      font-weight: ${props.theme.font.fontWeight.black};
      text-transform: ${props.theme.font.textTransform.upper};
      border-radius: 3.4rem;
      box-shadow: 0 1px 7px 0 ${props.theme.colors.black.light2};
      background-image: linear-gradient(95deg, #53b2fe 1%, #065af3 130%);
      border: none;
      cursor: pointer;
  `
);

export const SelectedViewBtn = styled.button(
  props => `
      padding: ${props.theme.spacing.small.s8} ${props.theme.spacing.large.l20};
      display: flex;
      font-size: ${props.theme.font.base};
      color: ${props.theme.colors.blue.base};
      font-weight: ${props.theme.font.fontWeight.black};
      text-transform: ${props.theme.font.textTransform.upper};
      border-radius: 3.4rem;
      box-shadow: 0 1px 7px 0 ${props.theme.colors.black.light2};
      background-color: ${props.theme.colors.white.base};
      border: none;
      cursor: pointer;
      outline: none;
  `
)

export const SelectedDealInfoBlock = styled.div(
  props => `
      width: 100%;
      display: flex;
      height:7rem;
      align-items: center;
      justify-content: center;
      padding: ${props.theme.spacing.base};
      border-top: 0.7px solid ${props.theme.colors.grey.lightba};
  `
);

export const SelectedDealText = styled.p(
  props => `
      font-size: ${props.theme.font.large.font14};
      color: ${props.theme.colors.grey.base};
      line-height: ${props.theme.font.lineHeight.large};
      text-align: ${props.theme.font.textAlign.center};
  `
);

export const SelectedUserRatingBlock = styled.div(
  props => `
      width: 100%;
      display: flex;
      height: 7rem;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background-color: ${props.theme.colors.grey.lightf6};
      padding: ${props.theme.spacing.base};
      border-top: 0.7px solid ${props.theme.colors.grey.lightba};
  `
);

export const SelectedRatingInfo = styled.div(
  props => `
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-bottom: ${props.theme.spacing.small.s5};  
  `
);

export const SelectedUserRating = styled.p(
  props => `
      padding: ${props.theme.spacing.small.s3} ${props.theme.spacing.small.s5};
      display: flex;
      font-size: ${props.theme.font.base};
      color: ${props.theme.colors.white.base};
      border-radius: ${props.theme.misc.borderRadius.base};
      font-weight: ${props.theme.font.fontWeight.bold};
      background-color: ${props.theme.colors.green.base};
      align-items: flex-end;
      span{
          font-size: ${props.theme.font.small.font8};
      }
  `
);

export const SectedTotalReview = styled.p(
  props => `
      padding-left: ${props.theme.spacing.small.s3};
      font-size: ${props.theme.font.small.font11};
      color: ${props.theme.colors.grey.base1};
  `
);

export const SelectedRecommendText = styled.p(
  props=> `
      font-size: ${props.theme.font.base};
      color: ${props.theme.colors.grey.light9b};
  `
);

export const SelectedLocation = styled.div(
  props => `
      width: 100%;
      display: flex;
      height: 5rem;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: ${props.theme.spacing.base};
      border-top: 0.7px solid ${props.theme.colors.grey.lightba};
  `
);

export const  SelectedLocationText = styled.p(
  props => `
      font-size: ${props.theme.font.large.font14};
      color: ${props.theme.colors.grey.base};
  `
);

export const SelectedCancelStatus = styled.div(
  props => `
      width: 100%;
      display: flex;
      height: 7rem;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background-color: ${props.theme.colors.grey.lightf6}; 
      padding: ${props.theme.spacing.base}; 
      border-top: 0.7px solid ${props.theme.colors.grey.lightba};
  `
);

export const  SelectedCancelText = styled.p(
  props => `
      font-size: ${props.theme.font.large.font14};
      color: ${props.theme.colors.grey.base};
  `
);

export const  SelectedCancelInfoText = styled.p(
  props => `
      font-size: ${props.theme.font.base};
      color: ${props.theme.colors.grey.light9b};
  `
);

export const SelectedEarlyCheck = styled.div(
  props => `
      width: 100%;
      display: flex;
      height: 5rem;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: ${props.theme.spacing.base};
      border-top: 0.7px solid ${props.theme.colors.grey.lightba};
  `
);

export const  SelectedEarlyText = styled.p(
  props => `
      font-size: ${props.theme.font.large.font14};
      color: ${props.theme.colors.grey.base};
  `
);

export const HtlRatingWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: ${props.theme.spacing.small.s5};
  `
)


export const StarDiv = styled(RatingStarIcon)(
  props => `
  width: .8rem;
  height: .8rem;
  margin-right:${props.theme.spacing.small.s2};
  color: ${props.theme.colors.yellow.darkerYellow};

`,
);
